import Action from 'actions';
import BaseExecutor from 'services/sports/default/base-executor';
import ExpMinWasSetForEachStackItemValidator from 'components/organisms/nhl-player-name-stacking/validators/exp-min-was-set-for-each-stack-item-validator';
import TeamWasSetForEachStackItemValidator from 'components/organisms/nhl-player-name-stacking/validators/team-was-set-for-each-stack-item-validator';
import PlayersQuantityValidForEachStackItemValidator from 'components/organisms/nhl-player-name-stacking/validators/players-quantity-valid-for-each-stack-item-validator';
import MaxPlayersInLineupValidator from 'components/organisms/nhl-player-name-stacking/validators/max-players-in-lineup-validator';
import ExpSumNotExceededForEachStackGroupValidator from 'components/organisms/nhl-player-name-stacking/validators/exp-sum-not-exceeded-for-each-stack-group-validator';
import BaseValidator from 'services/validations/base-validator';

class ControlledNameStackingValidatorBuilder extends BaseExecutor {
    getInterface() {
        const {
            stacks: {nhlName: stacking},
            sportConfig,
        } = Action.getState();

        const validator = new BaseValidator();

        if (!stacking.isEnabled()) {
            return validator;
        }

        const expMinWasSetForEachStackItemValidator = new ExpMinWasSetForEachStackItemValidator();
        expMinWasSetForEachStackItemValidator.setDependencies({stacking});

        const teamWasSetForEachStackItemValidator = new TeamWasSetForEachStackItemValidator();
        teamWasSetForEachStackItemValidator.setDependencies({stacking});

        const playersQuantityValidForEachStackItemValidator = new PlayersQuantityValidForEachStackItemValidator();
        playersQuantityValidForEachStackItemValidator.setDependencies({stacking});

        const maxPlayersInLineupValidator = new MaxPlayersInLineupValidator();
        maxPlayersInLineupValidator.setDependencies({stacking, sportConfig});

        const expSumNotExceededForEachStackGroupValidator = new ExpSumNotExceededForEachStackGroupValidator();
        expSumNotExceededForEachStackGroupValidator.setDependencies({stacking});

        validator.addSubValidators([
            expMinWasSetForEachStackItemValidator,
            teamWasSetForEachStackItemValidator,
            playersQuantityValidForEachStackItemValidator,
            maxPlayersInLineupValidator,
            expSumNotExceededForEachStackGroupValidator,
        ]);

        return validator;
    }
}

export {ControlledNameStackingValidatorBuilder};
